import React, {
    useState,
    useEffect
}
from "react";

import {
    useHistory
}
from "react-router-dom";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import
{
    faFileLines,
    faChevronRight,
    faCircleInfo,
    faChevronDown
}
from "@fortawesome/free-solid-svg-icons";


export default function HomeDocumentCard(
{
    id,
    sequence,
    image,
    title,
    description,
    documentCount,
    accentColour,
    delay = 0
})
{
    //--------------------------------------------------------
    // Router
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [hover, setHover] =
        useState(false);

    const [ready, setReady] =
        useState(false);

    const [expanded, setExpanded] =
        useState(false);


    //--------------------------------------------------------
    // Initial expansion
    //--------------------------------------------------------

    useEffect(
        function()
        {
            console.log(
                "SEQUENCE: ",
                sequence
            );

            if(sequence === 0)
            {
                setExpanded(
                    true
                );
            }
        },
        [sequence]
    );


    //--------------------------------------------------------
    // Entrance delay
    //--------------------------------------------------------

    useEffect(
        function()
        {
            const timer =
                setTimeout(
                    function()
                    {
                        setReady(
                            true
                        );
                    },
                    delay
                );

            return function()
            {
                clearTimeout(
                    timer
                );
            };
        },
        [delay]
    );


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const goDocuments =
        () =>
        {
            history.push(
                "/documents/" + id
            );
        };


    //========================================================
    // Main card
    //========================================================

    const containerStyle =
    {
        position:
            "relative",

        display:
            "flex",

        width:
            "calc(100% - 20px)",

        margin:
            "10px",

        marginTop:
            "15px",

        borderRadius:
            "6px",

			overflow:
			    "visible",

        //----------------------------------------------------
        // Flat glass surface
        //----------------------------------------------------

        background:
            "rgba(255,255,255,0.76)",

        backdropFilter:
            "blur(14px)",

        WebkitBackdropFilter:
            "blur(14px)",

        border:
            "1px solid rgba(255,255,255,0.72)",

        boxShadow:
            hover
                ?
                `
                0 14px 30px rgba(15,18,22,0.17),
                inset 0 1px 0 rgba(255,255,255,0.76)
                `
                :
                `
                0 6px 18px rgba(15,18,22,0.10),
                inset 0 1px 0 rgba(255,255,255,0.70)
                `,

        opacity:
            ready
                ?
                1
                :
                0,

        transform:
            ready
                ?
                (
                    hover
                        ?
                        "translateY(-1px)"
                        :
                        "translateY(0px)"
                )
                :
                "translateY(18px)",

        transition:
            "opacity .6s ease, " +
            "transform .6s cubic-bezier(.22,1,.36,1), " +
            "box-shadow .25s ease"
    };


    //========================================================
    // Left image panel
    //========================================================

	const imagePanelStyle =
	{
	    width:
	        "104px",

	    flexShrink:
	        0,

	    display:
	        "flex",

	    justifyContent:
	        "center",

	    alignItems:
	        "center",

	    position:
	        "relative",

	    overflow:
	        "hidden",

	    //----------------------------------------------------
	    // Make this a TILE within the outer card
	    //----------------------------------------------------
	    margin:
	        "8px 0px 8px 8px",

	    //----------------------------------------------------
	    // Keep internal geometry square
	    //----------------------------------------------------
	    borderRadius:
	        "0px",

	    //----------------------------------------------------
	    // Graphite / charcoal stage
	    //----------------------------------------------------
	    background:
	        `
	        linear-gradient(
	            135deg,
	            #30353a 0%,
	            #1c2024 52%,
	            #0e1012 100%
	        )
	        `,

	    border:
	        "1px solid rgba(0,0,0,0.18)",

	    boxShadow:
	        `
	        inset 0 1px 0 rgba(255,255,255,0.08),
	        inset -1px 0 0 rgba(255,255,255,0.035)
	        `
	};


    //--------------------------------------------------------
    // Large black watermark
    //--------------------------------------------------------

    const watermarkStyle =
    {
        position:
            "absolute",

        width:
            "82px",

        height:
            "82px",

        right:
            "-18px",

        bottom:
            "-14px",

        color:
            "#000000",

        opacity:
            0.30,

        transform:
            "rotate(-8deg)",

        pointerEvents:
            "none"
    };


    //--------------------------------------------------------
    // Document image
    //--------------------------------------------------------

    const imageStyle =
    {
        width:
            "76px",

        height:
            "76px",

        objectFit:
            "contain",

        padding:
            "7px",

        boxSizing:
            "border-box",

        position:
            "relative",

        zIndex:
            2,

        //----------------------------------------------------
        // Smoked glass image holder
        //----------------------------------------------------

        background:
            hover
                ?
                "rgba(5,7,9,0.60)"
                :
                "rgba(5,7,9,0.46)",

        border:
            "1px solid rgba(255,255,255,0.16)",

        borderRadius:
            "0px",

        boxShadow:
            hover
                ?
                `
                0 10px 22px rgba(0,0,0,0.32),
                inset 0 1px 0 rgba(255,255,255,0.08)
                `
                :
                `
                0 8px 18px rgba(0,0,0,0.22),
                inset 0 1px 0 rgba(255,255,255,0.06)
                `,

        filter:
            "contrast(1.04) saturate(1.03)",

        transform:
            hover
                ?
                "scale(1.025)"
                :
                "scale(1)",

        transition:
            "all .25s ease"
    };


    //========================================================
    // Right content
    //========================================================

    const contentStyle =
    {
        flex:
            1,

        display:
            "flex",

        flexDirection:
            "column",

        padding:
            "14px 18px",

        minWidth:
            0
    };


    //========================================================
    // Header
    //========================================================

    const headerStyle =
    {
        display:
            "flex",

        justifyContent:
            "space-between",

        alignItems:
            "center"
    };


    const titleStyle =
    {
        fontSize:
            "14px",

        fontWeight:
            600,

        color:
            "#22272b"
    };


    const infoStyle =
    {
        display:
            "flex",

        alignItems:
            "center",

        gap:
            "5px",

        cursor:
            "pointer",

        color:
            "#858b90",

        fontSize:
            "11px",

        userSelect:
            "none"
    };


    //========================================================
    // Description
    //========================================================

    const descriptionWrapperStyle =
    {
        display:
            "grid",

        gridTemplateRows:
            expanded
                ?
                "1fr"
                :
                "0fr",

        transition:
            "grid-template-rows .35s ease",

        marginTop:
            expanded
                ?
                "10px"
                :
                "0px"
    };


    const descriptionStyle =
    {
        fontSize:
            "12px",

        color:
            "#555d63",

        lineHeight:
            "18px",

        opacity:
            expanded
                ?
                1
                :
                0,

        transition:
            "opacity .25s ease"
    };


    //========================================================
    // Document counter
    //========================================================

    const documentCounterStyle =
    {
        display:
            "flex",

        alignItems:
            "center",

        width:
            "180px",

        padding:
            "6px",

        borderRadius:
            "0px",

        //----------------------------------------------------
        // Pale smoked glass
        //----------------------------------------------------

        background:
            "rgba(25,29,33,0.045)",

        border:
            "1px solid rgba(25,29,33,0.09)"
    };


    const documentIconStyle =
    {
        width:
            "34px",

        display:
            "flex",

        justifyContent:
            "center"
    };


    //--------------------------------------------------------
    // Dark document count block
    //--------------------------------------------------------

	const documentCountStyle =
	{
	    flex:
	        1,

	    height:
	        "28px",

	    display:
	        "flex",

	    justifyContent:
	        "center",

	    alignItems:
	        "center",

	    borderRadius:
	        "0px",

	    //----------------------------------------------------
	    // Bright OmniScan information accent
	    //----------------------------------------------------

	    background:
	        "linear-gradient(180deg, #45afe0 0%, #2695cc 100%)",

	    color:
	        "#ffffff",

	    fontWeight:
	        700,

	    fontSize:
	        "14px",

	    boxShadow:
	        `
	        inset 0 1px 0 rgba(255,255,255,0.24),
	        0 2px 5px rgba(38,149,204,0.18)
	        `
	};


    const documentLabelStyle =
    {
        width:
            "60px",

        textAlign:
            "center",

        fontSize:
            "12px",

        color:
            "#62686d",

        fontWeight:
            500
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div
            style={containerStyle}
            onMouseEnter={
                () =>
                {
                    setHover(
                        true
                    );
                }
            }
            onMouseLeave={
                () =>
                {
                    setHover(
                        false
                    );
                }
            }
        >

            {/* ================================================
                CHARCOAL IMAGE PANEL
            ================================================= */}

            <div style={imagePanelStyle}>


                {/* Black watermark */}

                <FontAwesomeIcon
                    icon={faFileLines}
                    style={watermarkStyle}
                />


                {/* Actual image */}

                <img
                    src={image}
                    alt=""
                    style={imageStyle}
                />

            </div>


            {/* ================================================
                CONTENT
            ================================================= */}

            <div style={contentStyle}>


                {/* --------------------------------------------
                    Header
                --------------------------------------------- */}

                <div style={headerStyle}>

                    <div style={titleStyle}>

                        {title}

                    </div>


                    <div
                        onClick={
                            () =>
                            {
                                setExpanded(
                                    !expanded
                                );
                            }
                        }
                        style={infoStyle}
                    >

                        <FontAwesomeIcon
                            icon={faCircleInfo}
                        />

                        <span>
                            Info
                        </span>

                        <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{
                                fontSize:
                                    "9px",

                                transform:
                                    expanded
                                        ?
                                        "rotate(180deg)"
                                        :
                                        "rotate(0deg)",

                                transition:
                                    "transform .35s ease"
                            }}
                        />

                    </div>

                </div>


                {/* --------------------------------------------
                    Description
                --------------------------------------------- */}

                <div style={descriptionWrapperStyle}>

                    <div
                        style={{
                            overflow:
                                "hidden"
                        }}
                    >

                        <div style={descriptionStyle}>

                            {description}

                        </div>

                    </div>

                </div>


                <div
                    style={{
                        flex:
                            1
                    }}
                />


                {/* --------------------------------------------
                    Footer
                --------------------------------------------- */}

                <div
                    style={{
                        display:
                            "flex",

                        justifyContent:
                            "space-between",

                        alignItems:
                            "center",

                        marginTop:
                            "10px"
                    }}
                >


                    {/* Document counter */}

                    <div style={documentCounterStyle}>

                        <div style={documentIconStyle}>

                            <FontAwesomeIcon
                                icon={faFileLines}
                                style={{
                                    color:
                                        "#292e32",

                                    fontSize:
                                        "15px"
                                }}
                            />

                        </div>


                        <div style={documentCountStyle}>

                            {
                                documentCount
                                    .toLocaleString()
                            }

                        </div>


                        <div style={documentLabelStyle}>

                            Docs

                        </div>

                    </div>


                    {/* Open documents */}

                    <FontAwesomeIcon
                        onClick={goDocuments}
                        icon={faChevronRight}
                        style={{
                            color:
                                hover
                                    ?
                                    "#252a2e"
                                    :
                                    "#777d82",

                            fontSize:
                                "18px",

                            cursor:
                                "pointer",

                            transform:
                                hover
                                    ?
                                    "translateX(2px)"
                                    :
                                    "translateX(0px)",

                            transition:
                                "all .2s ease"
                        }}
                    />

                </div>

            </div>

        </div>
    );
}